import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const CanvasActionButton = ({ i, icon, actionName, doAction, mode }) => {
  const isSelected = mode === actionName.toLowerCase();
  const {t} = useTranslation();

  return (
    <Box
      position="absolute"
      right={24}
      bottom={16 + 46 * i}
      display="flex"
      gap={2}
      alignItems="center"
      zIndex={9999}
    >
      <Typography variant="body1">{t(`eventManager.floorPlan.${actionName}`)}</Typography>
      <IconButton
        onClick={doAction}
        sx={{
          backgroundColor: isSelected ? "white" : "rgb(6,6,6,0.2)",
          borderRadius: 1,
          width: 32,
          height: 32,
          color: isSelected ? "black" : "white",
          "&:hover": {
            backgroundColor: isSelected ? "white" : "rgb(6,6,6,0.2)",
            color: isSelected ? "black" : "white",
          },
        }}
      >
        {icon}
      </IconButton>
    </Box>
  );
};

export default CanvasActionButton;